import { Component } from '@angular/core';
import { _MSGTYPES } from '../../shared/constant/msgType';
import { isArray } from '../../shared/utils/common';
import { TplAuditData } from '../../msg-interface/data-model';
import { MsgTemplateAudit } from '../../msg-interface/msg-template-audit';

@Component({
  selector: 'icc-voice-tpl-audit',
  templateUrl: './voice-tpl-audit.component.html',
  styleUrls: ['./voice-tpl-audit.component.less'],
})
export class VoiceTplAuditComponent implements MsgTemplateAudit {
  constructor() {}
  SCENE = 'icc-msg-tpl-audit';
  type = _MSGTYPES.MT.VOICE.type;
  // 模板列表
  tplList: any;
  // 数据操作状态
  operate = { normal: 0, add: 1, delete: 2, update: 3 };
  // 是否打开修改标记
  openEffect: boolean;
  tableConfig = {
    header: ['类型', '条件名称', '条件描述'],
    attr: [
      {
        name: 'conType',
        type: 'object',
      },
      {
        name: 'name',
        type: 'object',
      },
      {
        name: 'desc',
        type: 'array',
      },
    ],
  };
  // 逻辑关系
  relationTypes = {
    1: '"与"关系',
    2: '"或"关系',
  };
  useTmplMethod: number;

  /* 赋值 */
  setData(data: TplAuditData[], useTmplMethod: number) {
    this.tplList = data;
    this.useTmplMethod = useTmplMethod;
  }
  /* 切换展示状态 */
  switchDisplayStatus(isOpenEffect: boolean) {
    this.openEffect = isOpenEffect;
  }

  // 判断执行条件中的有用的执行条件数量是否大于一
  isRealConditionsOverOne(list) {
    if (list && isArray(list)) {
      let temp = list.filter(item => {
        return item.type === 1 || item.type === 0;
      });
      if (temp && temp.length > 1) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
}
